import StoreModule from "@/utils/StoreModule";

const customsServices = StoreModule("/customs/customs-services");

export default customsServices;
